import React from 'react';

import { MenuTreeVariant } from 'common/views/menuTree/MenuTree.view';
import NavMenu from 'common/views/menuTree/NavMenu';
import { PanelSetupRequired } from 'core/components/editor/EditToggle';
import { IPanelProps, Panel } from 'core/decorators/Panel';
// import ConnectedMenu from "./ConnectedMenu";
import MenuConfig from './MenuConfig';

/**
 * @overview: Displays links to all page paths within the current
 * container. For testing purposes only.
 *
 * @author: jesposito
 */

interface IMenuPanelState {
	expanded: { [id: string]: boolean; };
}

@Panel({id: "menu", configClass: MenuConfig})
export class MenuPanel extends React.Component<IPanelProps<MenuConfig>> {

	public state = { expanded: {} };

	public render() {

		if (!this.props.config.links || !this.props.config.links.ids) {
			return (
				<PanelSetupRequired description="Add Some Menu Links" />
			);
		}

		return (
			<NavMenu
				expanded={this.state.expanded}
				menu={this.props.config.links}
				onExpandChange={this.onExpand}
				variant={MenuTreeVariant.NAVBAR}
				viewKey="menu-tree"
			/>
		);
	}

	private onExpand = (id: string, isExpanded: boolean) => {
		this.setState({
			expanded: {...this.state.expanded, [id]: isExpanded}
		});
	}
}



// WEBPACK FOOTER //
// ./src/panels/menu/MenuPanel.panel.tsx